module.exports = __webpack_public_path__ + "static/media/shareLockGuide8_Jap.8e4e4161.jpg";